




































































import Vue from 'vue';
import router from '../../router';

export default Vue.extend({
  name: 'List',
  props: ['histories', 'isLoading', 'rowsPerPageItems', 'hideActions', 'isShowSearch'],
  methods: {
    // TODO: 外だし
    isShowThumnail(fileName: string) {
      let ext = fileName!.split('.').pop();
      if (ext === null) {
        return false;
      }
      ext = ext!.toLowerCase();
      if (ext === 'jpg' || ext === 'jpeg' || ext === 'png') {
        return true;
      }
      return false;
    },
    imageURL(txHash: string) {
      return `https://s3.amazonaws.com/open-apostille-nemgallary-production/${txHash}.jpg`;
    },
    pushDetail(txHash: string) {
      router.push(`/detail/${txHash}`);
    },
    pushOwner(owner: string) {
      router.push(`/owner/${owner}`);
    },
  },
  data() {
    return {
      headers: [
        { text: '', value: 'action', sortable: false },
        { text: this.$t('common.img').toString(), value: 'image', sortable: false },
        { text: this.$t('common.filename').toString(), value: 'filename', sortable: false },
        { text: this.$t('common.tag').toString(), value: 'tag', sortable: false },
        { text: this.$t('common.owner').toString(), value: 'owner', sortable: false },
        { text: this.$t('common.txHash').toString(), value: 'txHash', sortable: false },
        { text: this.$t('common.timestamp').toString(), value: 'timestamp', sortable: true },
        { text: this.$t('common.uploadAt'), value: 'updatedAt', sortable: true },
      ],
      pagination: {
        sortBy: 'updateAt',
        descending: true,
        rowsPerPgae: 25,
      },
      search: '',
    };
  },
});
